export default __webpack_public_path__ + "static/media/dark-zip.d5142197.png";